import { useStores } from "./useStores";
import type { ProjectFolderStoreInstance } from "@/stores/projects/ProjectFolderStore";

export function useProjectFolderStore(): ProjectFolderStoreInstance {
  const { projectFolderStore } = useStores();
  return projectFolderStore;
}
